import React from 'react';
import { Text, i18n, tokens } from '@simplybenefits/sb-ui-library';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';

/**
 *
 * @param {*} props
 */
export default function VirtualHealthcare({classes, expanded, virtualHealthcare, handleChange, theme}) {
    return (
        <div style={ classes.block }>
            <Accordion
                square
                onChange={handleChange('virtualHealthcare')}
                style={{ boxShadow: 'none' }}
                disableGutters={true}
            >
                <AccordionSummary
                    classes={{
                        content: classes.panelContent,
                        expanded: classes.expanded,
                        root: classes.root
                    }}
                    expandIcon={expanded.includes('virtualHealthcare') ? <RemoveIcon /> : <AddIcon />}
                    sx={classes.accordionSummary}
                >
                    <Text medium bold>{ i18n.t(tokens.titles.virtualHealthCare) }</Text>
                </AccordionSummary>
                <AccordionDetails style={classes.panelDetails}>
                    
                {
                    virtualHealthcare.isEligible === 1 ?
                        <React.Fragment>
                            {
                                    virtualHealthcare.includeMaple === 1 ?
                                <>
                                    <Text small bold margin="20px 0px 10px 0px">
                                        { i18n.t(tokens.labels.coverage.virtualHealthcareDetails, { virtualHealthcareType: "Maple"}) }
                                    </Text>
                                    <ul style={{ listStyle: 'disc', paddingLeft: '16px', marginLeft: '1px' }}>
                                        <li><Text small margin="0px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.medicalDiagnosis) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.prescriptionsAndRequisitions) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.specialistReferrals) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.mentalHealthSupport) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.chronicIllnessManagementAndPrevention) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.healthCoachingAndAdvice) }</Text></li>
                                    </ul>
                                    <Text small margin="10px 0px 0px 0px">
                                        { i18n.t(tokens.labels.coverage.registerTodayAt) } <a href="http://getmaple.ca/simply-benefits" target="_blank" rel="noopener noreferrer">{ i18n.t(tokens.labels.coverage.registrationLink) }</a>
                                    </Text>
                                </>
                                :
                                null
                            }
                            {
                                    virtualHealthcare.includeGotodoctor === 1 &&
                                <>
                                    <Text small bold margin="20px 0px 10px 0px">
                                        { i18n.t(tokens.labels.coverage.gotodoctorCaDetails) }
                                    </Text>
                                    <Text small margin="20px 0px 10px 0px">
                                        { i18n.t(tokens.labels.coverage.gotodoctorCa) }
                                    </Text>
                                    <ul style={{ listStyle: 'disc', paddingLeft: '16px', marginLeft: '1px' }}>
                                        <li><Text small margin="0px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.licensedCanadianPhysicians) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.onSiteDiagnosticTesting) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.continuityOfCare) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.dedicatedPortalAndSupport) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.prescriptionAndProductDiscount) }</Text></li>
                                    </ul>
                                    <Text small margin="10px 0px 0px 0px">
                                        { i18n.t(tokens.labels.coverage.bookTodayAt) }<a href="http://gotodoctor.ca/simplybenefits" target="_blank" rel="noopener noreferrer">gotodoctor.ca/simplybenefits</a>.
                                    </Text>
                                </>
                            }
                            {
                                virtualHealthcare.includeDialogue === 1 &&
                                <>
                                    <Text small bold margin="20px 0px 10px 0px">
                                        { i18n.t(tokens.labels.coverage.virtualHealthcareDetails, { virtualHealthcareType: "Dialogue"}) }
                                    </Text>
                                    <ul style={{ listStyle: 'disc', paddingLeft: '16px', marginLeft: '1px' }}>
                                        <li><Text small margin="0px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.unlimitedVirtualMedicalCare) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.videoBasedMedicalConsultations) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.supportForWideVarietyOfIssues) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.personalizedFollowUps) }</Text></li>
                                        <li><Text small margin="5px 0px 0px 0px">{ i18n.t(tokens.labels.coverage.consultationsWithOtherAlliedHealthProfessionals) }</Text></li>
                                    </ul>
                                    <Text small margin="10px 0px 0px 0px">
                                        { i18n.t(tokens.labels.coverage.registerTodayAt) }<a href="https://pages-support.dialogue.co/signup/" target="_blank" rel="noopener noreferrer">dialogue.co/signup</a>.
                                    </Text>
                                </>
                            }

                        </React.Fragment>
                        :
                        <div style={classes.row}>
                            <Text small bold margin="20px 0px 10px 0px">
                                { i18n.t(tokens.labels.coverage.ineligibleForBenefit)}
                            </Text>
                        </div>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    )
}